import type { PropsWithChildren } from 'react';

import { createContext, useContext, useEffect, useState } from 'react';
import {
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

import { PATH_DASHBOARD } from '../../routes/paths';

type Tab = {
  label: string;
  value: string;
};

export const defaultTabs: Tab[] = [
  {
    label: 'profile',
    value: 'profile',
  },
  // {
  //   value: 'documents',
  //   label: 'documents',
  // },
  {
    label: 'documents',
    value: 'vault',
  },
  {
    label: 'placements',
    value: 'placements',
  },
  {
    label: 'implementation_plan',
    value: 'implementation-plan',
  },
];

type ClientDetailsNavigatorContextType = {
  currentTab: string;
  id: string;
  tabs: Tab[];
};

const defaultClientDetailsNavigatorContextValue = {
  currentTab: 'profile',
  id: '',
  tabs: defaultTabs,
};

export const ClientDetailsNavigatorContext =
  createContext<ClientDetailsNavigatorContextType>(
    defaultClientDetailsNavigatorContextValue
  );

type ClientDetailsNavigatorContextProviderProps = PropsWithChildren<any>;

export const ClientDetailsNavigatorContextProvider = ({
  children,
}: ClientDetailsNavigatorContextProviderProps) => {
  const [contextValue, setContextValue] =
    useState<ClientDetailsNavigatorContextType>(
      defaultClientDetailsNavigatorContextValue
    );

  const navigate = useNavigate();
  const { id } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    if (id) {
      setContextValue((prev) => ({ ...prev, id }));

      if (pathname) {
        setContextValue((prev) => ({ ...prev }));
      }
    } else {
      navigate(PATH_DASHBOARD.client.list);
    }
  }, [id, navigate, pathname]);

  const currentTab =
    contextValue.tabs.find((tab) => {
      if (!id) return false;
      const path = `${PATH_DASHBOARD.client.details(id)}/${tab.value}`;
      const match = matchPath({ end: false, path }, location.pathname);
      return !!match;
    }) || defaultTabs[0];

  return (
    <ClientDetailsNavigatorContext.Provider
      value={{ ...contextValue, currentTab: currentTab.value }}
    >
      {children}
    </ClientDetailsNavigatorContext.Provider>
  );
};

export const useClientDetailsNavigatorContext = () => {
  return useContext(ClientDetailsNavigatorContext);
};
